import React from 'react';
import { Link } from 'react-router-dom';
import { examData } from '../data/examData';

// Split exams into Banking + SSC for a balanced 2-column footer block
const BANKING_EXAM_IDS = [
  'rbi-grade-b', 'nabard-grade-a',
  'sbi-po', 'sbi-clerk',
  'ibps-po', 'ibps-clerk',
  'ibps-rrb-po', 'ibps-rrb-clerk'
];
const SSC_EXAM_IDS = [
  'ssc-cgl', 'ssc-chsl', 'ssc-mts', 'ssc-cpo', 'ssc-gd', 'ssc-steno'
];

const pickExams = (ids) =>
  ids.map((id) => examData[id]).filter(Boolean);

const Footer = () => {
  const bankingExams = pickExams(BANKING_EXAM_IDS);
  const sscExams = pickExams(SSC_EXAM_IDS);

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_vidya365-coaching/artifacts/051wobd3_IMG-20260204-WA0032.jpg" 
              alt="Vidya365" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Empowering students to achieve their government job dreams through quality education
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/exams" className="text-gray-400 hover:text-white transition-colors">All Exams</Link></li>
              <li><Link to="/student-benefits" className="text-gray-400 hover:text-white transition-colors">Features</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/start-preparation" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/latest-updates" className="text-gray-400 hover:text-white transition-colors">Latest Update</Link></li>
              <li><Link to="/previous-year-question-paper" className="text-gray-400 hover:text-white transition-colors">Free PYQ Library</Link></li>
              <li><Link to="/typing-test" className="text-gray-400 hover:text-white transition-colors">Free Typing Test</Link></li>
              <li><Link to="/ai-interview" className="text-gray-400 hover:text-white transition-colors">AI Mock Interview <span className="text-yellow-400 text-xs">NEW</span></Link></li>
              <li><Link to="/daily-quiz" className="text-gray-400 hover:text-white transition-colors">Daily Current Affairs Quiz</Link></li>
              <li><Link to="/admin/login" className="text-gray-400 hover:text-red-400 transition-colors">Staff Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Exam Info — Banking</h4>
            <ul className="space-y-2 text-sm">
              {bankingExams.map((exam) => (
                <li key={exam.id}>
                  <Link
                    to={`/exams/${exam.id}`}
                    className="text-gray-400 hover:text-white transition-colors"
                    data-testid={`footer-exam-${exam.id}`}
                  >
                    {exam.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Exam Info — SSC</h4>
            <ul className="space-y-2 text-sm">
              {sscExams.map((exam) => (
                <li key={exam.id}>
                  <Link
                    to={`/exams/${exam.id}`}
                    className="text-gray-400 hover:text-white transition-colors"
                    data-testid={`footer-exam-${exam.id}`}
                  >
                    {exam.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Connect With Us</h4>
            <p className="text-gray-400 mb-4 text-sm">Stay updated with the latest exam notifications and tips</p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/vidyaa365/" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded hover:bg-red-500 transition-colors">
                <span className="sr-only">Facebook</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="https://www.instagram.com/vidya365365" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded hover:bg-red-500 transition-colors">
                <span className="sr-only">Instagram</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"/></svg>
              </a>
              <a href="https://www.youtube.com/channel/UCLHEDyf9t4VIUp5gatsmhyQ" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded hover:bg-red-500 transition-colors">
                <span className="sr-only">YouTube</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <h4 className="text-sm font-bold mb-3 text-gray-300">Popular Coaching in Karol Bagh, Delhi</h4>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500">
            <Link to="/best-ssc-coaching-in-karol-bagh-delhi" className="hover:text-white">Best SSC Coaching in Karol Bagh</Link>
            <Link to="/best-bank-coaching-in-karol-bagh-delhi" className="hover:text-white">Best Bank Coaching in Karol Bagh</Link>
            <Link to="/best-ssc-cgl-coaching-in-karol-bagh-delhi" className="hover:text-white">Best SSC CGL Coaching</Link>
            <Link to="/best-ssc-chsl-coaching-in-karol-bagh-delhi" className="hover:text-white">Best SSC CHSL Coaching</Link>
            <Link to="/best-sbi-po-coaching-in-karol-bagh-delhi" className="hover:text-white">Best SBI PO Coaching</Link>
            <Link to="/best-ibps-po-coaching-in-karol-bagh-delhi" className="hover:text-white">Best IBPS PO Coaching</Link>
            <Link to="/best-rbi-grade-b-coaching-in-karol-bagh-delhi" className="hover:text-white">Best RBI Grade B Coaching</Link>
            <Link to="/coaching-centre-near-me" className="hover:text-white">Coaching Centre Near Me</Link>
            <Link to="/best-coaching-karol-bagh-delhi" className="hover:text-white">Coaching in Delhi</Link>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Vidya365. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
